<template>

        <v-select
                prepend-icon="account_tree"
                :items="getItems"
                v-model="item"
                label="Medios de pago"
                :loading="loading"
                :error="hasInputErrors('paymentMethods')"
                :error-messages="getInputErrors('paymentMethods')"
                color="secondary"
                item-color="secondary"
                :clearable="clearable"
                :multiple="multiple"
                :chips="chips"
                :solo="solo"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'



    export default {
        name: "PaymentMethodCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {type: [String, Array]},
            clearable: {type:Boolean, default: false},
            multiple: {type:Boolean, default: false},
            solo: {type:Boolean, default: false},
            chips: {type:Boolean, default: false}
        },
        data() {
            return {
                items: ['CASH', 'DEBIT', 'BANK_TRANSFER', 'MP_TRANSFER', 'RAPPI', 'PEDIDOS_YA'],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            },
          getItems(){
             return this.items.map(item => ({text: this.$t('delivery.payment.method.'+item) , value: item}))
          }
        },

    }
</script>

<style scoped>

</style>

